import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  variant: 'solid',
  fontFamily: 'accent',
  fontWeight: 'bold',
  fontSize: 'sm',
  pt: '0.5',
};
